import Quill from 'quill';

import { formats } from '.';

Object.keys(formats).forEach((formatName) => {
  const format = formats[formatName];

  Quill.register(
    {
      [`formats/${format.blotName}`]: format,
    },
    true,
  );
});
